<template>
  <div>
    <MaintenanceAlert v-if="hasMaintenanceUSDT" />
    <div v-else>
      <div v-if="detailInfo">
        <div
          :class="hasStepGuide ? 'in-process-step-guide' : 'top-up-in-process'"
        >
          <top-up-success
            class="summary-form"
            :detail-info="detailInfo"
            :amount="detailInfo.amount"
            :transfer="{ value: detailInfo.coinNetwork }"
            :coin-type="detailInfo.coinType"
            :payment-method="{
              value: detailInfo.paymentMethod,
              icon: detailInfo.coinType
            }"
          />
        </div>
        <div
          class="user-hint mt-1 mb-2 d-flex"
          :class="hasStepGuide ? '' : 'justify-content-center'"
        >
          <user-hint :class="showUserGuide ? 'd-lg-none' : ''" />
        </div>
      </div>
      <div
        v-else-if="!showConfirmation"
        class="width-content mb-2"
      >
        <b-row class="add-fund-container mx-0">
          <b-col
            :md="hasStepGuide ? 12 : 9"
            data-testid="card-content-container-usdt"
            class="p-0 card-content"
          >
            <div
              data-testid="section-usdt-payment-info"
              class="usdt-payment-info p-0"
            >
              <payment-infor
                :method="paymentMethod"
                :transfer="transferNetwork"
                :coin-types="coinTypes"
                :transfer-networks="transferNetworks"
                @on-change="handleChangeMethod"
                @on-change-transfer="handleChangeTransferNetwork"
                @handleVerifications="handleVerifications"
              />
            </div>

            <div
              data-testid="usdt-top-up-form"
              class="usdt-top-up-amount mt-2 p-0"
            >
              <!-- :is-toggle="isToggle" -->
              <top-up-amount
                :verification="verification"
                :payment-method="paymentMethod"
                :transfer="transferNetwork"
                :amount="amount"
                :account="account"
                :amount-tip="amountTip"
                :percentage-tip="currentTip"
                :tip-index="currentTipIndex"
                :show-tips-input="showTipsForAM"
                @on-confirm="handleShowConfirm"
                @handleVerifications="handleVerifications"
              />
            </div>
          </b-col>

          <b-col
            v-if="!hasStepGuide"
            cols="12"
            md="9"
            :lg="hasStepGuide ? 12 : 3"
            class="payment-user-guide card-content"
          >
            <user-guide v-if="showUserGuide" />
          </b-col>
        </b-row>
        <div class="user-hint mt-1 mb-2 d-flex">
          <user-hint :class="showUserGuide ? 'd-lg-none' : ''" />
        </div>
      </div>
      <div
        v-else
      >
        <b-row class="w-100 width-content add-fund-container">
          <b-col
            :md="hasStepGuide ? 12 : 9"
            class="card-content p-0"
          >
            <div
              class="usdt-confirm-amount p-0"
            >
              <!-- :is-toggle="isToggle" -->
              <confirm-amount
                :expires-in="expiresIn"
                :transaction-info="transactionInfo"
                :amount="amount"
                :account="account"
                :billing="billing"
                :payment-method="paymentMethod"
                :transfer="transferNetwork"
                :amount-tip="amountTip"
                :current-tip="currentTip"
                :show-tips-input="showTipsForAM"
                :transaction-type="transactionType"
                :verification="verification"
                @on-prev="handlePrev"
                @handleShowSuccess="handleShowSuccess"
              />
            </div>
          </b-col>

          <b-col
            v-if="!hasStepGuide"
            cols="12"
            md="9"
            :lg="hasStepGuide ? 12 : 3"
            class="payment-user-guide card-content"
          >
            <user-guide v-if="showUserGuide" />
          </b-col>
        </b-row>
        <div class="user-hint mt-1 mb-2 d-flex">
          <user-hint :class="showUserGuide ? 'd-lg-none' : ''" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable prefer-destructuring */
import { BRow, BCol } from 'bootstrap-vue'
import {
  PAYMENT_GATE_STATUS,
  PAYMENT_METHOD,
} from '@/constants'
import envMixin from '@/mixins/envMixin'
import { createNamespacedHelpers } from 'vuex'
import stepGuideMixin from '@/mixins/stepGuideMixin'
import authMixin from '@/mixins/authMixin'
import UserHint from '@/components/UserHint.vue'
import UserGuide from '@/components/UserGuide.vue'
import paymentMixin from '@/mixins/paymentMixin'
import PaymentInfor from '@/views/payment/components/USDT/PaymentInfo.vue'
import ConfirmAmount from '@/views/payment/components/USDT/ConfirmAmount.vue'
import TopUpSuccess from '@/views/payment/components/USDT/TopUpSuccess.vue'
import { toastification } from '@core/mixins/toast'
import { getCookie } from '@/libs/common'
import MaintenanceAlert from '@/views/payment/components/MaintenanceAlert.vue'
import TopUpAmount from './TopUpAmount.vue'

const { mapGetters, mapActions } = createNamespacedHelpers('payment')
const { mapGetters: mapGettersAuth } = createNamespacedHelpers('auth')

export default {
  components: {
    MaintenanceAlert,
    TopUpSuccess,
    ConfirmAmount,
    BRow,
    BCol,
    UserHint,
    UserGuide,
    PaymentInfor,
    TopUpAmount,
  },

  mixins: [envMixin, stepGuideMixin, authMixin, paymentMixin, toastification],

  data() {
    return {
      verification: {},
      paymentMethod: {},
      transferNetwork: {},
      showConfirmation: false,
      amount: 0,
      account: {},
      transactionInfo: '',
      detailInfo: null,
      billing: [],
      showIntro: false,
      isShowSuccessPage: false,

      contentModal: {},
      usdtPaymentModal: {
        title: 'How to add fund with USDT?',
        description: '',
        video: 'https://www.youtube.com/embed/SiK4v1j-XUM',
        guideURL: process.env.VUE_APP_GUIDE_TO_TOP_UP_USDT,
      },
      usdtPaymentModalNoStep: {
        title: 'How to add fund with USDT?',
        description: '',
        video: 'https://www.youtube.com/embed/ZVEI9F5JQ-o',
        guideURL: process.env.VUE_APP_GUIDE_TO_TOP_UP_USDT,
      },

      currentTip: null,
      amountTip: null,
      currentTipIndex: null,
      showTipsForAM: false,

      transactionType: '',

      expiresIn: 0,
    }
  },
  computed: {
    ...mapGetters(['status', 'message', 'listTicket', 'verificationUSDT', 'ticketAuto']),
    ...mapGettersAuth(['user']),

    hasMaintenanceUSDT() {
      return this.usdtPaymentInfo?.status === PAYMENT_GATE_STATUS.MAINTENANCE
    },

    usdtPaymentInfo() {
      return this.paymentInfo.USDT
    },

    coinTypes() {
      return this.usdtPaymentInfo?.stableCoins?.map(item => ({
        value: item.value,
        name: item.name,
        icon: item.icon,
      }))
    },

    transferNetworks() {
      return this.usdtPaymentInfo?.info?.filter(item => item.status === 'available').map(item => ({
        value: item.additionalInfo.usdtChain,
        name: item.additionalInfo.usdtChainName,
        userName: item.additionalInfo.username,
        add: item.to,
        qrCodeUrl: item.qrCodeUrl,
      }))
    },

    percentFee() {
      return this.user?.data?.plans?.transferFee?.USDT || 0
    },
  },

  watch: {
    listTicket: {
      handler(val) {
        if (val) {
          const itemDetail = val?.content?.find(
            item => item?.details?.paymentMethod === PAYMENT_METHOD.USDT
              && item.status === 'opening',
          )
          this.detailInfo = itemDetail?.details
        }
      },
      deep: true,
      immediate: true,
    },

    // ticketAuto: {
    //   handler(val) {
    //     if (val) {
    //       if (val?.status === 'opening') {
    //         this.detailInfo = val?.details
    //         this.handleShowSuccess()
    //       }
    //     }
    //   },
    //   deep: true,
    //   immediate: true,
    // },
  },

  created() {
    this.setTransferNetwork()

    const cookieData = getCookie('add_fund_data')

    if (cookieData) {
      try {
        const decodedData = decodeURIComponent(cookieData)
        const parsedData = JSON.parse(decodedData)

        this.showConfirmation = true
        if (parsedData.transactionInfo) {
          this.transactionInfo = parsedData.transactionInfo || ''
        }
        if (parsedData.amount) {
          this.amount = parsedData.amount || 0
        }
        if (parsedData.account) {
          this.account = parsedData.account || {}
        }
        if (parsedData.paymentMethod) {
          this.paymentMethod = parsedData.paymentMethod || {}
        }
        if (parsedData.transferNetwork) {
          const currentNetwork = this.transferNetworks.find(
            network => network.value === parsedData.transferNetwork.value,
          )
          this.transferNetwork = { ...parsedData.transferNetwork, add: currentNetwork.add, qrCodeUrl: currentNetwork.qrCodeUrl } || {}
        }
        if (parsedData.amountTip) {
          this.amountTip = parsedData.amountTip || null
        }
        if (parsedData.currentTip) {
          this.currentTip = parsedData.currentTip || null
        }
        if (parsedData.showTipsForAM) {
          this.showTipsForAM = parsedData.showTipsForAM || false
        }
        if (parsedData.transactionType) {
          this.transactionType = parsedData.transactionType || ''
        }
        if (parsedData.verification) {
          this.verification = parsedData.verification || {}
        }
      } catch (error) {
        this.showConfirmation = false
      }
    }
  },

  methods: {
    ...mapActions(['verificationsUSDT']),
    setTransferNetwork() {
      this.paymentMethod = this.coinTypes[0]
      this.transferNetwork = this.transferNetworks[0]
    },

    handleChangeMethod(method) {
      this.paymentMethod = method
      this.handleVerifications({ amount: this.amount, tipAMAmount: this.amountTip })
    },

    handleChangeTransferNetwork(transfer) {
      this.transferNetwork = transfer
      this.handleVerifications({ amount: this.amount, tipAMAmount: this.amountTip })
    },

    startCountdown() {
      clearInterval(this.intervalActive)
      this.expiresIn = 60 * 60
      this.intervalActive = setInterval(() => {
        this.expiresIn -= 1
        if (this.expiresIn <= 0) {
          clearInterval(this.intervalActive)
        }
      }, 1000)
    },

    async handleVerifications(data) {
      this.amount = data.amount
      this.amountTip = data.tipAMAmount
      if (this.amount) {
        const params = {
          details: {
            amount: data.amount,
            paymentMethod: 'USDT',
            coinType: this.paymentMethod.value,
            coinNetwork: this.transferNetwork.value,
            tipAMAmount: data.tipAMAmount,
          },
        }
        await this.verificationsUSDT(params)
        if (this.status) {
          this.startCountdown()
          this.verification = {
            // eslint-disable-next-line no-underscore-dangle
            id: this.verificationUSDT.verification._id,
            toBalanceAmount: this.verificationUSDT.toBalanceAmount,
            bankTransferAmount: this.verificationUSDT.bankTransferAmount,
            serviceCharge: this.verificationUSDT.serviceCharge,
            taxCharge: this.verificationUSDT.taxCharge,
            paymentGateCharge: this.verificationUSDT.paymentGateCharge,
            percentFee: this.percentFee,
            taxRate: this.taxRate,
          }
        } else {
          this.toastFailure(this.message)
        }
      }
    },

    setAddFundCookie(name, value) {
      const serializedValue = typeof value === 'object' ? JSON.stringify(value) : value
      document.cookie = `${name}=${encodeURIComponent(serializedValue)};path=/`
    },

    handleShowConfirm(data) {
      this.showConfirmation = true
      this.amount = data.amount
      this.account = data.account
      this.currentTip = data.currentTip
      this.amountTip = data.tipAMAmount
      this.currentTipIndex = data.currentTipIndex
      this.showTipsForAM = data.showTipsForAM
      if (this.verificationUSDT && this.verificationUSDT.verification) {
        this.verification = {
          // eslint-disable-next-line no-underscore-dangle
          id: this.verificationUSDT.verification._id,
          toBalanceAmount: this.verificationUSDT.toBalanceAmount,
          bankTransferAmount: this.verificationUSDT.bankTransferAmount,
          serviceCharge: this.verificationUSDT.serviceCharge,
          taxCharge: this.verificationUSDT.taxCharge,
          paymentGateCharge: this.verificationUSDT.paymentGateCharge,
          percentFee: this.percentFee,
          taxRate: this.taxRate,
        }
      }

      const cookieData = {
        transactionInfo: this.transactionInfo,
        amount: this.amount,
        account: this.account,
        paymentMethod: this.paymentMethod,
        transferNetwork: this.transferNetwork,
        amountTip: this.amountTip,
        currentTip: this.currentTip,
        showTipsForAM: this.showTipsForAM,
        transactionType: this.transactionType,
        verification: this.verification,
      }

      this.setAddFundCookie('add_fund_data', cookieData)
    },

    handlePrev(data) {
      this.showConfirmation = false
      this.amount = data.amount
      this.transactionInfo = data.transactionId
      this.billing = data.billing
      this.currentTip = data.currentTip
      this.amountTip = data.amountTip
      this.showTipsForAM = data.showTipsForAM
    },

    handleShowSuccess() {
      this.showConfirmation = false
      this.detailInfo = this.ticketAuto?.details
      this.amount = 0
      this.currentTip = null
      this.amountTip = null
      this.currentTipIndex = null
      this.showTipsForAM = false
    },
  },
}
</script>
